import * as types from "./types";

export const getReportsRequest = (payload) => ({
  type: types.GET_REPORTS_REQUEST,
  payload,
});

export const getReportsResponse = (payload) => ({
  type: types.GET_REPORTS_RESPONSE,
  payload,
});

export const getReportDetailRequest = (payload) => ({
  type: types.GET_REPORT_DETAIL_REQUEST,
  payload,
});

export const getReportDetailResponse = (payload) => ({
  type: types.GET_REPORT_DETAIL_RESPONSE,
  payload,
});

export const createReportRequest = (payload) => ({
  type: types.CREATE_REPORT_REQUEST,
  payload,
});

export const createReportResponse = (payload) => ({
  type: types.CREATE_REPORT_RESPONSE,
  payload,
});

export const exportReportSheetRequest = (payload) => ({
  type: types.EXPORT_REPORT_SHEET_REQUEST,
  payload,
});

export const updateReportRequest = (payload) => ({
  type: types.UPDATE_REPORT_REQUEST,
  payload,
});

export const updateReportResponse = (payload) => ({
  type: types.UPDATE_REPORT_RESPONSE,
  payload,
});

export const getReportCommentsRequest = (payload) => ({
  type: types.GET_REPORT_COMMENTS_REQUEST,
  payload,
});

export const getReportCommentsResponse = (payload) => ({
  type: types.GET_REPORT_COMMENTS_RESPONSE,
  payload,
});

export const createReportCommentRequest = (payload) => ({
  type: types.CREATE_REPORT_COMMENT_REQUEST,
  payload,
});

export const createReportCommentResponse = (payload) => ({
  type: types.CREATE_REPORT_COMMENT_RESPONSE,
  payload,
});
